export default __webpack_public_path__ + "static/media/TassAppLogoSimple.f0f0ce79.svg";